import { render } from "./MaintenanceModule.vue?vue&type=template&id=162765c2&scoped=true"
import script from "./MaintenanceModule.vue?vue&type=script&lang=js"
export * from "./MaintenanceModule.vue?vue&type=script&lang=js"

import "./MaintenanceModule.vue?vue&type=style&index=0&id=162765c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162765c2"]])

export default __exports__